/* eslint-disable jsx-a11y/label-has-associated-control */
import { BsInfo } from "react-icons/bs";

interface ITooltipProps {
  text: string;
}
interface ICustomTooltipProps {
  text: string;
  children: React.ReactNode;
  className?: string;
}

export function Tooltip({ text }: ITooltipProps) {
  return (
    <div className="dropdown dropdown-hover inline-block">
      <label
        tabIndex={0}
        className="p-0 text-white bg-primary rounded-full top-[4px]"
      >
        <BsInfo className="bg-primary rounded-full text-lg ml-2" />
      </label>
      <div
        tabIndex={0}
        className="dropdown-content menu p-3 bg-gray-900/90 text-white rounded rounded-tl-none text-sm w-96 top-[16px] max-w-[200px] lg:max-w-[300px] right-0 md:left-[16px] z-[198]"
      >
        <p>{text}</p>
      </div>
    </div>
  );
}
export function CustomTooltip({
  children,
  text,
  className,
}: ICustomTooltipProps): JSX.Element {
  return (
    <div className="dropdown dropdown-hover inline-block">
      <div tabIndex={0}>{children}</div>
      <div
        tabIndex={0}
        className={`${
          className || ""
        } dropdown-content menu p-2 bg-gray-900/90 text-white rounded rounded-lg text-sm  top-0 right-[30px] z-[198]`}
      >
        <p>{text}</p>
      </div>
    </div>
  );
}
